/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-fragments */
/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import SearchBox from '../SearchBox';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 300,
    maxWidth: 300,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  menuItemRoot: {
    backgroundColor: '#FFF !important',
    '&:hover': {
      color: '#26BBED',
      backgroundColor: '#FFF',
      '& .MuiCheckbox-root': {
        color: '#26BBED',
      },
    },
  },
  menuItemSelected: {
    backgroundColor: '#FFF !important',
  },
  menuItemCheckboxChecked: {
    color: '#26BBED !important',
  },
  indeterminateCheckBoxRoot: {
    color: '#26BBED',
  },
  selectAllText: {
    fontSize: 14,
    color: '#33333380',
  },
  itemText: {
    fontSize: 16,
  },
}));

export default function DropDown({
  propValues = ['Oliver Hansen', 'Van Henry', 'April Tucker', 'Ralph Hubbard'],
  multiple = true,
  label,
  selectAllEnable = true,
  searchEnable = true,
  onChangeHandler,
  ...rest
}) {
  const classes = useStyles();
  const [value, setValue] = React.useState([]);
  const [menuListOpened, setMenuListOpened] = React.useState(false);
  const [orgValues, setOrgValues] = React.useState(propValues);

  const handleChange = (event) => {
    event.preventDefault();
    const temp = event.target.value;
    if (temp[temp.length - 1] === 'all') {
      setValue(value.length === propValues.length ? [] : propValues);
      onChangeHandler &&
        onChangeHandler(value.length === propValues.length ? [] : propValues);
      return;
    } else if (temp[temp.length - 1] === 'search') {
      setValue(temp.slice(0, temp.length - 1));
      onChangeHandler && onChangeHandler(temp.slice(0, temp.length - 1));
      return;
    }
    setValue(temp);
    onChangeHandler && onChangeHandler(temp);
  };

  const renderValue = (selected) => {
    if (multiple) {
      if (!menuListOpened) {
        if (selected.length > 1)
          return `${selected[0]} + ${selected.length - 1}`;
        else return selected;
      } else if (menuListOpened) {
        if (selected.length >= 3) {
          return `${selected.length} selected`;
        } else {
          return selected.join(', ');
        }
      }
    } else return selected;
  };

  const selectAll = (event) => {
    event.stopPropagation();
    if (event.target.checked) {
      setValue(propValues);
    } else {
      setValue([]);
    }
  };

  const filterPropValues = (text) => {
    if (text !== '') {
      setOrgValues(
        propValues.filter((item) => {
          return item.toLowerCase().includes(text.toLowerCase());
        })
      );
    } else {
      setOrgValues(propValues);
    }
  };

  return (
    <div>
      <FormControl className={classes.formControl}>
        {label && <InputLabel>{label}</InputLabel>}
        <Select
          multiple={multiple}
          value={value}
          onChange={handleChange}
          input={<Input />}
          renderValue={renderValue}
          onOpen={() => {
            setMenuListOpened(true);
            setOrgValues(propValues);
          }}
          onClose={() => {
            setMenuListOpened(false);
            setOrgValues(propValues);
          }}
          {...rest}
        >
          {searchEnable && (
            <Box p={2} value='search'>
              <SearchBox onSearch={filterPropValues} />
            </Box>
          )}
          {multiple && selectAllEnable && (
            <MenuItem
              classes={{
                selected: classes.menuItemSelected,
              }}
              value='all'
            >
              <Checkbox
                onChange={selectAll}
                checked={value.length === propValues.length}
                indeterminate={
                  value.length > 0 && value.length < propValues.length
                }
                classes={{
                  root:
                    value.length > 0 && value.length < propValues.length
                      ? classes.indeterminateCheckBoxRoot
                      : null,
                  checked: classes.menuItemCheckboxChecked,
                }}
              />
              <ListItemText
                primary='Select All'
                classes={{
                  primary: classes.selectAllText,
                }}
              />
            </MenuItem>
          )}
          {orgValues.map((propValue) => (
            <MenuItem
              key={propValue}
              value={propValue}
              classes={{
                root: classes.menuItemRoot,
                selected: classes.menuItemSelected,
              }}
            >
              {multiple && (
                <Checkbox
                  checked={value.indexOf(propValue) > -1}
                  classes={{
                    checked: classes.menuItemCheckboxChecked,
                  }}
                />
              )}
              <ListItemText
                primary={propValue}
                classes={{
                  primary: classes.itemText,
                }}
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

DropDown.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  propValues: PropTypes.array,
  multiple: PropTypes.bool,
  label: PropTypes.string,
  selectAllEnable: PropTypes.bool,
  searchEnable: PropTypes.bool,
};

DropDown.defaultProps = {
  propValues: ['Oliver Hansen', 'Van Henry', 'April Tucker', 'Ralph Hubbard'],
  multiple: true,
  label: 'label',
  selectAllEnable: true,
  searchEnable: true,
};
